/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Title_WorksInputs */

const en_resume_title_works = /** @type {(inputs: Resume_Title_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Works`)
};

const ar_resume_title_works = /** @type {(inputs: Resume_Title_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أعمالي`)
};

const bn_resume_title_works = /** @type {(inputs: Resume_Title_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কাজ`)
};

const de_resume_title_works = /** @type {(inputs: Resume_Title_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekte`)
};

const es_resume_title_works = /** @type {(inputs: Resume_Title_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyectos`)
};

const fr_resume_title_works = /** @type {(inputs: Resume_Title_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projets`)
};

const pt_resume_title_works = /** @type {(inputs: Resume_Title_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projetos`)
};

const zh_resume_title_works = /** @type {(inputs: Resume_Title_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作品`)
};

const tr_resume_title_works = /** @type {(inputs: Resume_Title_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeler`)
};

const ru_resume_title_works = /** @type {(inputs: Resume_Title_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проекты`)
};

const pl_resume_title_works = /** @type {(inputs: Resume_Title_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekty`)
};

/**
* | output |
* | --- |
* | "Works" |
*
* @param {Resume_Title_WorksInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_title_works = /** @type {((inputs?: Resume_Title_WorksInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Title_WorksInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_title_works(inputs)
	if (locale === "bn") return bn_resume_title_works(inputs)
	if (locale === "de") return de_resume_title_works(inputs)
	if (locale === "es") return es_resume_title_works(inputs)
	if (locale === "fr") return fr_resume_title_works(inputs)
	if (locale === "pt") return pt_resume_title_works(inputs)
	if (locale === "zh") return zh_resume_title_works(inputs)
	if (locale === "tr") return tr_resume_title_works(inputs)
	if (locale === "ru") return ru_resume_title_works(inputs)
	if (locale === "pl") return pl_resume_title_works(inputs)
	return en_resume_title_works(inputs)
});